module.exports = __webpack_public_path__ + "static/media/wallet.01d1fff2.svg";